/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useEffect } from 'react';
import singleDeviceStyles from '../../styles.module.css';
import { DeviceDetailsContext } from '../../index';
import { Col, notification, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import ComputerStatus from './components/ComputerStatus';
import ProductStatus from './components/ProductStatus';
import VirusScanning from './components/VirusScanning';
import FullScan from './components/FullScan';
import Reboot from './components/Reboot';
import QuickScan from './components/QuickScan';
import Signature from './components/Signature';
import ScanDetails from './components/ScanDetails';
import axios from 'axios';
import { handleApiError } from '../../../../../../services/utils/errorHandler';
import ConfigContext from '../../../../../../components/ConfigContext';

const WindowsDefender = () => {
  const { config } = useContext(ConfigContext);
  const deviceDetails = useContext(DeviceDetailsContext);
  const { t } = useTranslation();

  useEffect(() => {
    // Update the current route's key
    deviceDetails.setCurrentRoute('windows-defender');
  }, []);

  const triggerScans = scan => {
    const requestPayload = {
      deviceIDs: [`${deviceDetails.deviceIdentifier}`],
      scanMode: `${scan}`,
    };

    axios
      .post(
        window.location.origin +
          config.serverConfig.invoker.uri +
          '/device-mgt/windows/v1.0' +
          '/admin/devices/scan',
        requestPayload,
      )
      .then(result => {
        if (result.status === 201) {
          notification.success({
            message: t('api_successMsg'),
            duration: 4,
            description: t('api_addScanMsg'),
          });
        } else {
          throw new Error();
        }
      })
      .catch(error => {
        handleApiError(error, t('api_retrieveDeviceDetailsError'), t);
      });
  };

  return (
    <div className={singleDeviceStyles.container}>
      <Row>
        <Col style={{ marginRight: 20 }}>
          <ComputerStatus />
        </Col>
        <Col style={{ marginRight: 20 }}>
          <ProductStatus />
        </Col>
        <Col>
          <VirusScanning />
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FullScan triggerScans={triggerScans} />
        </Col>
        <Col md={8}>
          <Reboot />
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <QuickScan triggerScans={triggerScans} />
        </Col>
        <Col md={8}>
          <Signature triggerScans={triggerScans} />
        </Col>
      </Row>
      <ScanDetails triggerScans={triggerScans} />
    </div>
  );
};

export default WindowsDefender;
